import { setLocales } from '@x_x_x/locales';
import { htmlEntitiesDecode } from '@x_x_x/utils';

try {
	setLocales(JSON.parse(htmlEntitiesDecode(document.getElementById('app-locales').innerHTML)) as Record<string, unknown>);
} catch (err) {
	// eslint-disable-next-line no-console
	console.error('FAILED PARSE APP LOCALES');
}

// eslint-disable-next-line import/no-unassigned-import
require('./start');
